import { Chip, Stack, Typography } from '@mui/material';
import { SpecificityObject } from '@silbo/core';
import { colors, palette } from '@silbo/ui';
import { useTranslation } from 'react-i18next';

type FareSpecificitiesProps = {
  specificities: SpecificityObject[];
  isDone?: boolean;
};

export function FareSpecificities({ specificities, isDone }: FareSpecificitiesProps) {
  const { t } = useTranslation('patient-transport');

  const fontSize = 14;

  return (
    <Stack
      direction="row"
      alignItems="flex-start"
      spacing={2}
      sx={{ opacity: isDone ? 0.5 : undefined, filter: isDone ? 'grayscale(1)' : undefined }}
    >
      <Typography variant="body2" sx={{ color: palette.text.primary, minWidth: 80, pt: '3px', fontSize }}>
        {t('fareDetails.specificities')}
      </Typography>
      <Stack direction="row" flexWrap="wrap" gap={1}>
        {specificities.map(({ name, id }) => (
          <Chip
            key={id}
            label={name}
            sx={{
              backgroundColor: colors.grey[10],
              color: colors.grey[70],
              borderRadius: 50,
              fontWeight: 500,
              fontSize,
              height: 18,
            }}
            size="small"
          />
        ))}
      </Stack>
    </Stack>
  );
}
